module.exports = __webpack_public_path__ + "static/media/note.b84be0ed.svg";